export const API_URL = window.location.href.includes('localhost') ?  "http://localhost/itasmartcommunities/api" : "https://ita-smartcommunities.hu/api";